import constants from '../constants';
import * as helpers from '../../helpers';
import { IframeConfig, IframeElementDataAttribute } from './getData';

const getIframeElement = (htmlDocument: Document, src: string, isVisible: boolean): HTMLIFrameElement => {
	const iframeElement = htmlDocument.createElement('iframe');
	iframeElement.className = constants.iframeClassName;
	iframeElement.src = src;
	iframeElement.setAttribute('frameborder', '0');
	iframeElement.setAttribute('width', '100%');
	iframeElement.setAttribute('height', '100%');

	if (isVisible === false) {
		helpers.setElementIsHidden(iframeElement);
	}

	return iframeElement;
};

const setElementContent = (
	htmlDocument: Document,
	iframeElement: HTMLIFrameElement,
	id: string,
	isVisible: boolean
): void => {
	const frame = htmlDocument.querySelector(`#${id}`) as HTMLElement;
	helpers.setElementIsEdited(frame);

	frame.innerHTML = '';

	if (!isVisible) {
		frame.style.pointerEvents = 'none';
	} else {
		frame.style.removeProperty('pointer-events');
	}

	// tslint:disable-next-line: max-line-length
	// when embed an iframe, inline-style 'transform: scale(0.99)' is set for iframe parent element in Safari (it seems that it comes from Reader code). It breaks correct position of iframe parent element. To fix it we have to add element between iframe and its parent element (object element is added because Reader has already correct styles for this element)
	const object = htmlDocument.createElement('object');
	object.className = constants.videoOrIframeWrapperId;
	object.appendChild(iframeElement);
	frame.appendChild(object);
};

export default (htmlDocument: Document, iframes: IframeConfig[]): void => {
	iframes.forEach(({
		isEditedFromBackoffice,
		id,
		defaultSrc,
		src,
		isVisible,
	}) => {
		if (!isEditedFromBackoffice) {
			return;
		}

		const iframeElement = getIframeElement(htmlDocument, src, isVisible);

		if (src !== defaultSrc) {
			helpers.setDataAttributes(iframeElement, {
				[IframeElementDataAttribute.edited]: true,
				[IframeElementDataAttribute.defaultSrc]: defaultSrc,
				[IframeElementDataAttribute.src]: src,
				[IframeElementDataAttribute.hidden]: !isVisible,
			});
		} else {
			if (!isVisible) {
				helpers.setDataAttributes(iframeElement, {
					[IframeElementDataAttribute.hidden]: true,
					[IframeElementDataAttribute.defaultSrc]: defaultSrc,
				});
			}
		}

		setElementContent(htmlDocument, iframeElement, id, isVisible);
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/indesignEditor/editableIframes/saveData.ts